import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // ================ PC端 ================
  {
    path: '/',
    component: () => import('../views/home/home.vue'),
    children: [
      {
        path: '',
        name: "home",
        component: () => import('../views/home/index.vue')
      },
	  {
	    path: 'distribute',
	    name: 'distribute',
	    component: () => import('../views/distribute/index.vue')
	  },
	  {
	    path: 'ecology',
	    name: 'ecology',
	    component: () => import('../views/ecology/index.vue')
	  },
	  {
	    path: 'join',
	    name: 'join',
	    component: () => import('../views/join/index.vue')
	  },
	  {
	    path: 'requirement',
	    name: 'requirement',
	    component: () => import('../views/requirement/index.vue')
	  },
	  {
	    path: 'reqdetail/:id',
	    name: 'requirementDetail',
	    component: () => import('../views/requirement/detail.vue')
	  },
	  {
	    path: 'audit',
	    name: 'audit',
	    component: () => import('../views/audit/index.vue')
	  },
      // {
      //   path: 'requirement',
      //   name: 'requirement',
      //   component: () => import('../views/requirement/index.vue')
      // },
   //    {
   //      path: 'reqdetail/:id',
   //      name: 'requirementDetail',
   //      component: () => import('../views/requirement/detail.vue')
   //    },
	  // {
	  //   path: 'distribute',
	  //   name: 'distribute',
	  //   component: () => import('../views/distribute/index.vue')
	  // },
   //    {
   //      path: 'ecology',
   //      name: 'ecology',
   //      component: () => import('../views/ecology/index.vue')
   //    },
   //    {
   //      path: 'customer',
   //      name: 'customer',
   //      component: () => import('../views/customer/index.vue')
   //    },
   //    {
   //      path: 'expdetail',
   //      name: 'expdetail',
   //      component: () => import('../views/customer/detail.vue')
   //    },
   //    {
   //      path: 'union',
   //      name: 'union',
   //      component: () => import('../views/union/index.vue')
   //    },
	  // {
	  //   path: 'cooperation',
	  //   name: 'cooperation',
	  //   component: () => import('../views/cooperation/index.vue')
	  // },
	  // {
	  //   path: 'join',
	  //   name: 'join',
	  //   component: () => import('../views/join/index.vue')
	  // },
   //    {
   //      path: 'aboutus',
   //      name: 'aboutus',
   //      component: () => import('../views/admin/aboutus.vue')
   //    },
   //    {
   //      path: 'contactus',
   //      name: 'contactus',
   //      component: () => import('../views/admin/aboutus.vue')
   //    },
   //    {
   //      path: 'forget',
   //      name: 'forget',
   //      component: () => import('../views/admin/forget.vue')
   //    }
    ]
  },
  
  {
    path: '/aboutus',
    name: 'aboutus',
    component: () => import('../views/admin/aboutus.vue')
  },
  {
    path: '/contactus',
    name: 'contactus',
    component: () => import('../views/admin/aboutus.vue')
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import('../views/admin/forget.vue')
  },
  
  
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/admin/login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/admin/register.vue')
  },
  {
    path: '/ecology/monitor',
    name: 'monitorDetail',
    component: () => import('../views/ecology/monitorDetail.vue')
  },
  // ================ 移动端 ================
  // {
  //   path: '/mobile',
  //   component: () => import('../views/mobile/home.vue'),
  //   children: [
  //     {
  //       path: 'index',
  //       name: "mobile-home",
  //       component: () => import('../views/mobile/index.vue')
  //     },
  //     {
  //       path: 'requirement',
  //       name: 'mobile-requirement',
  //       component: () => import('../views/mobile/requirement.vue')
  //     },
  //     {
  //       path: 'mine',
  //       name: 'mine',
  //       component: () => import('../views/mobile/mine.vue')
  //     },
  //   ]
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
